import React from 'react';

const FlagMu = props => (
  <svg viewBox="0 0 6 4" {...props}>
    <path fill="#00A551" d="M0 0h6v4H0z" />
    <path fill="#FFD500" d="M0 0h6v3H0z" />
    <path fill="#1A206D" d="M0 0h6v2H0z" />
    <path fill="#EA2839" d="M0 0h6v1H0z" />
  </svg>
);

export default FlagMu;
